import { Assistant } from "./data";

/** `{name}` placeholders in an i18n string. Unknown placeholders are left as they are. */
export function fill(template: string, vars: Record<string, string | number>): string {
	return template.replace(/\{(\w+)\}/g, (match, key: string) => (key in vars ? String(vars[key]) : match));
}

const PROMPT_ENDPOINT: Record<Assistant, string> = {
	chatgpt: "https://chatgpt.com/?q=",
	claude: "https://claude.ai/new?q=",
};

/** Where the assistant opens when no prompt is attached (the disabled "Plan in ..." button). */
export const ASSISTANT_HOME: Record<Assistant, string> = {
	chatgpt: "https://chatgpt.com/",
	claude: "https://claude.ai/new",
};

/**
 * Link that opens the assistant with `prompt` prefilled. Every prompt carries `setup` (the localised "if Stippl
 * is not connected yet, explain how to add it" sentence) so someone who has not connected Stippl is walked
 * through it first.
 */
export function assistantPromptHref(assistant: Assistant, prompt: string, setup: string): string {
	return PROMPT_ENDPOINT[assistant] + encodeURIComponent(prompt.trim() + setup);
}
